"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectDropdown = void 0;
const react_1 = __importStar(require("react"));
const Types_1 = require("Types");
const useOnOutsideClick_1 = require("@/Hooks/useOnOutsideClick");
const Typography_1 = __importStar(require("../../UI/Typography"));
const style = __importStar(require("./styled"));
const Checkbox_1 = __importDefault(require("../Checkbox"));
const WRAPPER_PADDINGS = 32;
const SelectDropdown = ({ options, optionsColor, value, setValue, values, setValues, label, labelColor, required, helpText, width, disabled, allowInput, error, takeContentWidth, enableValidation, validationFunc, placeholder, isMultiSelect, isSearchDropdown, className, inputAutoComplete = 'off' }) => {
    const [initOptions, setInitOptions] = (0, react_1.useState)(options);
    const [searchValue, setSearchValue] = (0, react_1.useState)(null);
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const [calculatedWidth, setCalculatedWidth] = (0, react_1.useState)(null);
    const wrapperRef = (0, react_1.useRef)(null);
    const listRef = (0, react_1.useRef)(null);
    const [errorMessage, setErrorMessage] = (0, react_1.useState)();
    const handleSearchValueChange = (value) => setSearchValue(value);
    const handleFocus = () => {
        if (!isSearchDropdown)
            return;
        handleSearchValueChange('');
        setIsOpen(true);
    };
    const changeValue = (option) => {
        var _a;
        if (enableValidation && validationFunc) {
            setErrorMessage(validationFunc((_a = option === null || option === void 0 ? void 0 : option.name) === null || _a === void 0 ? void 0 : _a.toString()));
        }
        setIsOpen(false);
        setValue(option);
        isSearchDropdown && handleSearchValueChange(null);
    };
    const handleChange = (e) => isSearchDropdown
        ? handleSearchValueChange(e.target.value)
        : changeValue({
            id: 'FreeText',
            name: e.target.value
        });
    const changeValues = (option) => {
        if (option.disabled) {
            return;
        }
        if (values.some(value => value.id === option.id)) {
            setValues(values.filter(value => value.id !== option.id));
        }
        else {
            setValues([...values, option]);
        }
    };
    const checkSelected = (id) => {
        if (isMultiSelect && values) {
            return values.some(value => value.id === id);
        }
        return id === (value === null || value === void 0 ? void 0 : value.id);
    };
    (0, react_1.useEffect)(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                setIsOpen(false);
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (!(initOptions === null || initOptions === void 0 ? void 0 : initOptions.length)) {
            setInitOptions(options);
        }
    }, [options]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (takeContentWidth && (listRef === null || listRef === void 0 ? void 0 : listRef.current)) {
            setCalculatedWidth(((_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) + WRAPPER_PADDINGS);
        }
    }, [takeContentWidth]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (enableValidation && validationFunc) {
            setErrorMessage(validationFunc((_a = value === null || value === void 0 ? void 0 : value.name) === null || _a === void 0 ? void 0 : _a.toString()));
        }
    }, [enableValidation]);
    (0, react_1.useEffect)(() => {
        if (isSearchDropdown) {
            searchValue
                ? setValues(initOptions.filter(option => ((option === null || option === void 0 ? void 0 : option.name) || '').toLowerCase().indexOf(searchValue === null || searchValue === void 0 ? void 0 : searchValue.toLowerCase()) > -1))
                : setValues(initOptions);
        }
    }, [isSearchDropdown, searchValue]);
    (0, useOnOutsideClick_1.useOnOutsideClick)(wrapperRef, () => setIsOpen(false));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        label && (react_1.default.createElement(style.SelectTitle, { labelColor: labelColor },
            react_1.default.createElement(style.Label, { required: required },
                react_1.default.createElement(Typography_1.default, { type: Typography_1.Types.LABEL_ON_FORM }, label)))),
        helpText && react_1.default.createElement(Typography_1.default, { type: Typography_1.Types.BODY_2 }, helpText),
        react_1.default.createElement(style.Wrapper, { tabIndex: 0, ref: wrapperRef, width: width || calculatedWidth, hasLabel: !!label || !!helpText, className: className },
            allowInput ? (react_1.default.createElement(style.HeaderInput, { disabled: disabled },
                react_1.default.createElement(style.Input, { type: "text", autoComplete: inputAutoComplete, onChange: handleChange, onFocus: handleFocus, value: searchValue !== null && searchValue !== void 0 ? searchValue : value === null || value === void 0 ? void 0 : value.name, disabled: disabled, error: error, placeholder: placeholder }),
                react_1.default.createElement(style.ArrowContainer, { onClick: () => (!disabled ? setIsOpen(!isOpen) : {}), type: Types_1.ButtonTypes.BUTTON },
                    react_1.default.createElement(style.ArrowIcon, { disabled: disabled, isOpen: isOpen, allowInput: allowInput })))) : (react_1.default.createElement(style.Header, { errorMessage: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.error, disabled: disabled, isOpen: isOpen, onClick: () => (!disabled ? setIsOpen(!isOpen) : {}), type: Types_1.ButtonTypes.BUTTON },
                react_1.default.createElement(style.HeaderTitle, { disabled: disabled, type: Typography_1.Types.BODY_1, optionsColor: optionsColor }, (value === null || value === void 0 ? void 0 : value.name) ? value.name : placeholder),
                react_1.default.createElement(style.ArrowIcon, { disabled: disabled, isOpen: isOpen }))),
            isOpen && !disabled && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(style.List, { ref: listRef, takeContentWidth: takeContentWidth, isOpen: isOpen }, options.map((item, i) => (react_1.default.createElement(react_1.Fragment, { key: i }, isMultiSelect ? (react_1.default.createElement(style.CheckboxContainer, { disabled: item.disabled },
                    react_1.default.createElement(Checkbox_1.default, { onChange: () => changeValues(item), checked: checkSelected(item === null || item === void 0 ? void 0 : item.id), disabled: item.disabled, label: item === null || item === void 0 ? void 0 : item.name }))) : (react_1.default.createElement(style.ListItem, { onClick: () => changeValue(item), disabled: (item === null || item === void 0 ? void 0 : item.id) === (value === null || value === void 0 ? void 0 : value.id), isSelected: checkSelected(item === null || item === void 0 ? void 0 : item.id) },
                    react_1.default.createElement(style.ListItemName, { type: Typography_1.Types.BODY_1, isSelected: checkSelected(item === null || item === void 0 ? void 0 : item.id), optionsColor: optionsColor, disabled: item.disabled }, item === null || item === void 0 ? void 0 : item.name))))))))))));
};
exports.SelectDropdown = SelectDropdown;
exports.default = exports.SelectDropdown;
